import React, { useState, useMemo } from 'react';

const TabListaEspera = ({
  listaEspera,
  onOfrecerCita,
  onEliminarDeLista,
  loading = false
}) => {
  const [busqueda, setBusqueda] = useState('');
  const [paginaActual, setPaginaActual] = useState(1);

  const itemsPorPagina = 8;

  const listroFiltrada = useMemo(() => {
    if (!busqueda.trim()) return listaEspera;

    const termino = busqueda.toLowerCase();
    return listaEspera.filter(item =>
      item.cliente_nombre?.toLowerCase().includes(termino) ||
      item.servicio_nombre?.toLowerCase().includes(termino)
    );
  }, [listaEspera, busqueda]);

  const totalPaginas = Math.ceil(listroFiltrada.length / itemsPorPagina);
  const listaEsperaPaginada = listroFiltrada.slice(
    (paginaActual - 1) * itemsPorPagina,
    paginaActual * itemsPorPagina
  );

  return (
    <div style={{ padding: '1.5rem' }}>
      {/* Búsqueda */}
      <div style={{
        marginBottom: '1.5rem',
        display: 'flex',
        gap: '1rem'
      }}>
        <input
          type="text"
          placeholder="Buscar por cliente o servicio..."
          value={busqueda}
          onChange={(e) => {
            setBusqueda(e.target.value);
            setPaginaActual(1);
          }}
          style={{
            flex: 1,
            padding: '0.75rem',
            border: '1px solid #d1d5db',
            borderRadius: '6px',
            fontSize: '0.95rem'
          }}
        />
        <button
          onClick={() => {
            setBusqueda('');
            setPaginaActual(1);
          }}
          style={{
            padding: '0.75rem 1.5rem',
            backgroundColor: '#e5e7eb',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontWeight: '600',
            fontSize: '0.95rem',
            transition: 'all 0.2s'
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#d1d5db'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#e5e7eb'}
        >
          Limpiar
        </button>
      </div>

      {/* Tarjetas */}
      {listaEsperaPaginada.length > 0 ? (
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
          gap: '1rem',
          marginBottom: '1.5rem'
        }}>
          {listaEsperaPaginada.map((item, idx) => (
            <div
              key={item.id || idx}
              style={{
                padding: '1.25rem',
                border: '1px solid #e5e7eb',
                borderRadius: '8px',
                backgroundColor: '#ffffff',
                transition: 'all 0.2s',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)';
                e.currentTarget.style.transform = 'translateY(-2px)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              {/* Header */}
              <div style={{ marginBottom: '1rem' }}>
                <h4 style={{ margin: '0 0 0.25rem 0', color: '#374151', fontWeight: '700' }}>
                  {item.cliente_nombre}
                </h4>
                <p style={{ margin: 0, color: '#6b7280', fontSize: '0.9rem' }}>
                  {item.servicio_nombre}
                </p>
              </div>

              {/* Información */}
              <div style={{
                padding: '1rem',
                backgroundColor: '#f9fafb',
                borderRadius: '6px',
                marginBottom: '1rem',
                fontSize: '0.85rem'
              }}>
                <div style={{ marginBottom: '0.5rem' }}>
                  <span style={{ color: '#6b7280', display: 'block' }}>En lista desde:</span>
                  <span style={{ color: '#374151', fontWeight: '600' }}>
                    {new Date(item.fecha_registro).toLocaleDateString('es-ES')}
                  </span>
                </div>

                {item.fecha_preferida && (
                  <div>
                    <span style={{ color: '#6b7280', display: 'block' }}>Disponible desde:</span>
                    <span style={{ color: '#374151', fontWeight: '600' }}>
                      {new Date(item.fecha_preferida).toLocaleDateString('es-ES')}
                    </span>
                  </div>
                )}
              </div>

              {/* Notas */}
              {item.notas && (
                <div style={{
                  padding: '0.75rem',
                  backgroundColor: '#fef3c7',
                  borderRadius: '6px',
                  marginBottom: '1rem',
                  fontSize: '0.85rem',
                  color: '#92400e',
                  borderLeft: '3px solid #f59e0b'
                }}>
                  {item.notas}
                </div>
              )}

              {/* Acciones */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '0.75rem'
              }}>
                <button
                  onClick={() => onOfrecerCita(item)}
                  disabled={loading}
                  style={{
                    padding: '0.6rem',
                    backgroundColor: '#10b981',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontWeight: '600',
                    fontSize: '0.85rem',
                    transition: 'all 0.2s',
                    opacity: loading ? 0.6 : 1
                  }}
                  onMouseOver={(e) => !loading && (e.target.style.opacity = '0.8')}
                  onMouseOut={(e) => !loading && (e.target.style.opacity = '1')}
                >
                  ✓ Ofrecer
                </button>

                <button
                  onClick={() => onEliminarDeLista(item.id)}
                  disabled={loading}
                  style={{
                    padding: '0.6rem',
                    backgroundColor: '#ef4444',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontWeight: '600',
                    fontSize: '0.85rem',
                    transition: 'all 0.2s',
                    opacity: loading ? 0.6 : 1
                  }}
                  onMouseOver={(e) => !loading && (e.target.style.opacity = '0.8')}
                  onMouseOut={(e) => !loading && (e.target.style.opacity = '1')}
                >
                  ✕ Eliminar
                </button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div style={{
          textAlign: 'center',
          padding: '3rem 1.5rem',
          backgroundColor: '#f9fafb',
          borderRadius: '8px',
          color: '#6b7280'
        }}>
          <p style={{ margin: 0, fontSize: '1.1rem', fontWeight: '500' }}>
            📭 No hay clientes en la lista de espera
          </p>
        </div>
      )}

      {/* Paginación */}
      {totalPaginas > 1 && (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '0.5rem',
          marginBottom: '1.5rem'
        }}>
          <button
            onClick={() => setPaginaActual(Math.max(1, paginaActual - 1))}
            disabled={paginaActual === 1}
            style={{
              padding: '0.5rem 0.75rem',
              border: '1px solid #d1d5db',
              borderRadius: '4px',
              cursor: 'pointer',
              fontWeight: '600'
            }}
          >
            ← Anterior
          </button>

          {Array.from({ length: totalPaginas }, (_, i) => i + 1).map(pagina => (
            <button
              key={pagina}
              onClick={() => setPaginaActual(pagina)}
              style={{
                padding: '0.5rem 0.75rem',
                border: pagina === paginaActual ? '2px solid #10b981' : '1px solid #d1d5db',
                backgroundColor: pagina === paginaActual ? '#d1fae5' : 'white',
                color: pagina === paginaActual ? '#10b981' : '#6b7280',
                borderRadius: '4px',
                cursor: 'pointer',
                fontWeight: pagina === paginaActual ? '700' : '600'
              }}
            >
              {pagina}
            </button>
          ))}

          <button
            onClick={() => setPaginaActual(Math.min(totalPaginas, paginaActual + 1))}
            disabled={paginaActual === totalPaginas}
            style={{
              padding: '0.5rem 0.75rem',
              border: '1px solid #d1d5db',
              borderRadius: '4px',
              cursor: 'pointer',
              fontWeight: '600'
            }}
          >
            Siguiente →
          </button>
        </div>
      )}

      {/* Resumen */}
      <div style={{
        padding: '1rem',
        backgroundColor: '#f3f4f6',
        borderRadius: '8px',
        textAlign: 'center',
        color: '#6b7280',
        fontSize: '0.9rem'
      }}>
        {listaEsperaPaginada.length} de {listroFiltrada.length} en espera
        {listroFiltrada.length < listaEspera.length && ` (${listaEspera.length - listroFiltrada.length} filtrados)`}
      </div>
    </div>
  );
};

export default TabListaEspera;
